const templateCache = new Map<string, ArrayBuffer>();
const MAX_CACHE_SIZE = 50 * 1024 * 1024; // 50MB limit
let currentCacheSize = 0;

/**
 * Gets a PDF template from cache or fetches it if not cached.
 * Implements LRU-style eviction when cache exceeds size limit.
 */
export async function getCachedTemplate(url: string): Promise<ArrayBuffer> {
  // Return cached template if available
  if (templateCache.has(url)) {
    return templateCache.get(url)!;
  }

  // Fetch template
  const bytes = await fetch(url).then((res) => res.arrayBuffer());
  const bytesSize = bytes.byteLength;

  // If single template exceeds cache limit, don't cache it
  if (bytesSize > MAX_CACHE_SIZE) {
    return bytes;
  }

  // Evict oldest entries if cache would exceed size limit
  while (currentCacheSize + bytesSize > MAX_CACHE_SIZE && templateCache.size > 0) {
    const firstKey = templateCache.keys().next().value!;
    const evictedBytes = templateCache.get(firstKey);
    if (evictedBytes) {
      currentCacheSize -= evictedBytes.byteLength;
    }
    templateCache.delete(firstKey);
  }

  // Add to cache
  templateCache.set(url, bytes);
  currentCacheSize += bytesSize;

  return bytes;
}
